export const roundToNearestHundred = (num) => {
  return Math.ceil(num / 10) * 10;
};

export const formatCurrency = (value) => {
  return `₦${ parseFloat(roundToNearestHundred(value)).toLocaleString() }`
}
